/** Sem acento e em minúsculas ("João" → "joao"). */
function semAcento(texto: string): string {
  return texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
}

/** Só letras e números ("(31) 98204-2887" → "31982042887", "RLMP 071" → "rlmp071"). */
function compacto(texto: string): string {
  return semAcento(texto).replace(/[^a-z0-9]/g, '');
}

/**
 * Busca livre usada nas listas do SI (Inventário, Solicitações): algum dos valores contém o
 * termo, ignorando acento, maiúsculas, espaço e pontuação — "rlmp 071" acha RLMP071, "joao"
 * acha João, "31982042887" acha "(31) 98204-2887". Termo vazio = tudo passa.
 */
export function textoCorresponde(valores: Array<string | null | undefined>, termo: string): boolean {
  const alvo = semAcento(termo.trim());
  if (!alvo) return true;
  const alvoCompacto = compacto(alvo);
  return valores.some((valor) => {
    if (!valor) return false;
    return semAcento(valor).includes(alvo) || (alvoCompacto.length > 0 && compacto(valor).includes(alvoCompacto));
  });
}
